import clsx from 'clsx';
import { __ } from '@wordpress/i18n';
import { useMemo } from '@wordpress/element';
import {
    useBlockProps,
    InnerBlocks,
} from '@wordpress/block-editor';
import InsSettings from './settings.js';

const Edit = ({
    attributes,
    setAttributes,
}) => {
    const { paginationType } = attributes;

    // Memoized template for Load More button
    const TEMPLATE_LOAD_MORE = useMemo(() => [
        [
            'vayu-blocks/advance-button',
            {
                className: clsx('post_pagination_loadmore', attributes.paginationType, 'load-more-btn'),
                content: __('Load More', 'text-domain'),
                linkUrl: '#',
                paddingType: 'linked',
                padding: 5,
                paddingUnit: 'px',
                buttonpaddingType: 'linked',
                buttonpadding: 10,
                buttonpaddingUnit: 'px',
                fontSize: 14,
                fontSizeUnit: 'px',
                widthType: 'inlinewidth',
            },
        ],
    ], [paginationType]);

    // Block properties
    const blockProps = useBlockProps({
        className: clsx(
            'vayu_blocks_post_pagination_wrap',
            'is-layout-flex',
            attributes.paginationType
        ),
    });

    return (
        <>
            <InsSettings
                attributes={attributes}
                setAttributes={setAttributes}
            />
            <div {...blockProps}>
                <InnerBlocks
                    template={TEMPLATE_LOAD_MORE}
                    templateLock="all"
                />
            </div>
        </>
    );
};

export default Edit;
